import { sharedEnvironment } from './environment.shared';

export const environment = {
  ...sharedEnvironment,
  withdrawMinBalance: Number(process.env['NG_APP_WITHDRAW_MIN_BALANCE']),
  birthDateConfig: {
    minAge: Number(process.env['NG_APP_BIRTH_DATE_MIN_AGE']),
    minYear: Number(process.env['NG_APP_BIRTH_DATE_MIN_YEAR']),
  },
  servicesConfig: {
    useApiURL: process.env['NG_APP_USE_API_URL'] === 'true',
    apiUrl: process.env['NG_APP_API_URL'] as string,
    apiUrlSuffix: process.env['NG_APP_API_URL_SUFFIX'] as string,
    filesURL: process.env['NG_APP_FILES_URL'] as string,
  },
  telegramAuthToken: process.env['NG_APP_TELEGRAM_AUTH_TOKEN'] as string,
  ofertaUrl: process.env['NG_APP_OFERTA_URL'] as string,
  translateRoute: process.env['NG_APP_TRANSLATE_ROUTE'] as string,
};
